<template>
    <footer class="bg-[#18181B]">
        <div class="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8 lg:py-32">
            <div class="xl:grid xl:grid-cols-3 xl:gap-8">
                <img class="h-9" :src="logoInkor" alt="Company name" />
                <div class="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
                    <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div>
                            <h3 class="text-sm/6 font-semibold text-white">
                                A Inkor
                            </h3>
                            <ul role="list" class="mt-6 space-y-4">
                                <li v-for="item in navigation.solutions" :key="item.name">
                                    <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm/6 font-semibold text-white">
                                Fale com a gente
                            </h3>
                            <ul role="list" class="mt-6 space-y-4">
                                <li class="text-sm/6 text-gray-400 hover:text-white">
                                    (48) 3356-5400
                                </li>
                                <li class="text-sm/6 text-gray-400 hover:text-white">
                                    sac@inkor.com.br
                                </li>
                                <!-- <li v-for="item in navigation.support" :key="item.name">
                  <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name }}</a>
                </li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="md:grid md:grid-cols-2 md:gap-8">
                        <div>
                            <h3 class="text-sm/6 font-semibold text-white">
                                Produtos
                            </h3>
                            <ul role="list" class="mt-6 space-y-4">
                                <li v-for="item in navigation.produtos" :key="item.name">
                                    <a :href="item.href" class="text-sm/6 text-gray-400 hover:text-white">{{ item.name
                                    }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm/6 font-semibold text-white">
                                Siga nas Redes
                            </h3>
                            <ul role="list" class="mt-6 space-y-4">
                                <li>
                                    <a href="https://instagram.com.br/instainkor" target="_blank" rel="noopener"
                                        class="flex gap-1.5 items-center text-sm/6 text-gray-400 hover:text-white">
                                        <InstagramIcon class="w-4 h-4" />
                                        Instagram
                                    </a>
                                </li>
                                <a href="https://www.facebook.com/inkor.industria" target="_blank" rel="noopener"
                                    class="flex gap-1.5 items-center text-sm/6 text-gray-400 hover:text-white">
                                    <FacebookIcon class="w-4 h-4" />
                                    Facebook
                                </a>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCmRWuPGeCxJ9cWqCwvX5BXg" target="_blank"
                                        rel="noopener"
                                        class="flex gap-1.5 items-center text-sm/6 text-gray-400 hover:text-white">
                                        <YoutubeIcon class="w-4 h-4" />
                                        Youtube
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-full items-center justify-center text-gray-400 mt-10 flex-wrap text-center text-sm">
                <span class="me-2">© Copyright 2003 - {{ new Date().getFullYear() }}</span>
                <span class="mx-2">|</span>
                <span class="ms-2 me-2">Inkor - 06.101.244/0001-47</span>
                <span class="mx-2">|</span>
                <span class="ms-2 me-2">Todos os direitos reservados</span>
                <span class="mx-2">|</span>
                <a href="/politica-de-privacidade" class="ms-2 hover:underline">
                    Política de privacidade
                </a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import AOS from "aos";
import "aos/dist/aos.css";
import {
    FacebookIcon,
    Instagram,
    InstagramIcon,
    YoutubeIcon,
} from "lucide-vue-next";
import { onMounted, ref } from "vue";
import logoInkor from "../assets/img/inkor-logo.png";

const navigation = {
    solutions: [
        { name: "Sobre nós", href: "/sobre-nos" },
        { name: "Trabalhe Conosco", href: "/vagas" },
        { name: "Fale Conosco", href: "/contato" },
        { name: "Blog", href: "/blog" },
    ],
    support: [
        { name: "Submit ticket", href: "#" },
        { name: "Documentation", href: "#" },
        { name: "Guides", href: "#" },
    ],
    produtos: [
        { name: "Aditivos", href: "/produtos/aditivos" },
        { name: "Argamassas", href: "/produtos/argamassas" },
        { name: "Argamassas Técnicas", href: "/produtos/argamassas-tecnicas" },
        { name: "Impermeabilizantes", href: "/produtos/impermeabilizantes" },
        { name: "Tintas", href: "/produtos/tintas-imobiliarias" },
    ],
    legal: [
        { name: "Terms of service", href: "#" },
        { name: "Privacy policy", href: "#" },
        { name: "License", href: "#" },
    ],
};

onMounted(() => {
    AOS.init({ duration: 800, once: true });
});
</script>
